function register(serviceDiscovery) {
  Genesys('registerPlugin', 'ServiceDiscovery', (ServiceDiscoveryPlugin) => {
    populateServiceInfo(serviceDiscovery, ServiceDiscoveryPlugin);
    ServiceDiscoveryPlugin.ready();
  });
}

function populateServiceInfo(serviceDiscovery, plugin) {
  const $$ = plugin.data;
  const serviceInfo = serviceDiscovery.resolveAllServices();

  for (const service in serviceInfo) {
    if (Object.prototype.hasOwnProperty.call(serviceInfo, service)) {
      $$(`domains.${service}`, serviceInfo[service].domain);
      $$(`uris.${service}`, serviceInfo[service].uri);
    }
  }
}

export default {
  register,
};
